import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

import { DESCRIPTION_MAX_LENGTH, validateOptionalField } from '../../utils/formValidation'

/**
 * Shared, OPTIONAL description input for every resource request form and admin
 * modal (issue #472). Renders its own <Grid item xs={12}>, so drop it straight
 * into the surrounding <Grid container> next to <CoreResourceFields />.
 *
 * Never pass `required`: `Resource.description` is blank=True, and a leftover
 * HTML required attribute would block AdminBookModal's real type='submit'
 * Approve/Disapprove button in a browser even with the JS validator fixed.
 *
 * Props:
 *   value, setValue     - description state (value may be undefined; coerced here)
 *   error, setError     - error-boolean state
 *   helper, setHelper   - helper-text state
 *   limit               - effective cap for validation. Admin modals must pass
 *                         descriptionLimit(props.description) so a row already
 *                         longer than the cap stays saveable (AC-15). Creation
 *                         forms may omit it and get the flat 500 cap.
 *   label               - field label (default "Description")
 *   rows                - textarea rows (default 3)
 */
const ResourceDescriptionField = ({
    value,
    setValue,
    error,
    setError,
    helper,
    setHelper,
    limit = DESCRIPTION_MAX_LENGTH,
    label = 'Description',
    rows = 3,
}) => {
    // Coerced once, here, so no consumer can crash the counter by passing
    // undefined (several admin modals initialise from a props key that may be
    // absent -- see AdminBookModal.test.js baseProps).
    const text = value ?? ''

    return (
        <Grid item xs={12}>
            <TextField
                fullWidth
                multiline
                rows={rows}
                value={text}
                onChange={e => setValue(e.target.value)}
                label={label}
                error={error}
                // The counter always reports against the constant 500 cap, so a
                // grandfathered row reads "812/500" -- informative, not blocking.
                helperText={helper || `${text.length}/${DESCRIPTION_MAX_LENGTH} characters`}
                onBlur={() => validateOptionalField(text, setError, setHelper, limit, label)}
            />
        </Grid>
    )
}

export default ResourceDescriptionField
